import * as React from "react";

import { tailwindTheme } from "../styles";

const { screens } = tailwindTheme;

export const useMediaQuery = (query: {
  size: keyof typeof screens;
  type: "max-width" | "min-width";
} | string): boolean => {
  /**
   * Args:
   * - query: string | object
   *   eg "(min-width: 640px)"
   *   or {
   *        size: "xs",
   *        type: "min-width",
   *      } -> xs, sm, md, lg, xl
   * https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
   * https://github.com/shadcn-ui/ui/blob/main/apps/www/hooks/use-media-query.tsx
   */

  const [value, setValue] = React.useState(false);

  let mediaQuery = query;
  if (typeof query === "object") {
    mediaQuery = `(${query.type}: ${screens[query.size]})`;
  }
  else {
    // this line is actually un-necessary
    // here for stopping TS from complaining
    mediaQuery = query;
  }

  React.useEffect(() => {
    const onChange = (event: MediaQueryListEvent) => {
      setValue(event.matches);
    };

    const result = matchMedia(mediaQuery);
    result.addEventListener("change", onChange);
    setValue(result.matches);

    return () => {
      return result.removeEventListener("change", onChange);
    };
  }, [query]);

  return value;
};
